import { useState } from 'react';
import { Box } from '@material-ui/core';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import AttachmentIcon from '@material-ui/icons/Attachment';
import PropTypes from 'prop-types';
import { alpha, makeStyles } from '@material-ui/core/styles';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { MEDIA_BASE_URL } from '../../../utils/useAxios';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);


const useStyles = makeStyles(theme => ({
    iconView: {
      //backgroundColor: alpha(blue['500'], 0.1),
      //color: blue['500'],
      //backgroundColor: alpha(theme.palette.warning.main, 0.25),
      color: '#5D4037',
      padding: 8,
      borderRadius: 4,
      '& .MuiSvgIcon-root': {
        display: 'block',
      },
      '&.web': {
        backgroundColor: alpha(theme.palette.warning.main, 0.1),
        color: theme.palette.warning.main,
      },
      '&.phone': {
        backgroundColor: alpha(theme.palette.success.main, 0.15),
        color: theme.palette.success.dark,
      },
    },
    wordAddress: {
      wordBreak: 'break-all',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 'bold',
      marginBottom: '1px',
      marginTop: '1px'
    },
    spacer:{
      marginBottom: '18px'
    }
}));


function CustomizedDialog(props) {
    const {open, setOpen, handleClickOpen, handleClose, url, modalTitle} = props
    return(
      <div>
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} style={{ minWidth: "550px", minHeight: "550px"}}>
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                <Typography fontSize={14}>
                    {modalTitle}
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <iframe src={`${MEDIA_BASE_URL}${url}`} style={{ minWidth: "550px", minHeight: "550px" }}>

                </iframe>
            {/*
            style={{ maxWidth: "100%", maxHeight: "calc(100vh - 64px)" }}
            <Typography gutterBottom>
                Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis
                in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
            </Typography>
            <Typography gutterBottom>
                Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis
                lacus vel augue laoreet rutrum faucibus dolor auctor.
            </Typography>
            <Typography gutterBottom>
                Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel
                scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus
                auctor fringilla.
            </Typography>*/}
            </DialogContent>
            <DialogActions>
            <Button autoFocus onClick={handleClose} color="primary">
                <Typography fontSize={14}>
                    Close
                </Typography>
            </Button>
            </DialogActions>
        </Dialog>
      </div>
    );
}

function NationalID(props){
    const classes = useStyles();
    const {national_id, showAttachment, setUrl, setModalTitle} = props;
    const newTitle = 'National ID'
    if(national_id){
        return(
            <Box display="flex" className={classes.spacer} alignItems="center" mb={{ xs: 4, sm: 6 }}>
            <Box className={classes.iconView}>
              <AttachmentIcon />
            </Box>
            <Box ml={5}>
              <Box component="span" fontSize={13} color="text.primary">
              </Box>
              <Box component="p" className={classes.wordAddress}>
                  <Box component="a" href="#" onClick={e => showAttachment(e, national_id, setUrl, newTitle, setModalTitle)}>
                    National ID
                  </Box>
              </Box>
            </Box>
          </Box>
        )
    }return null
}


function PassportPhoto(props){
    const classes = useStyles();
    const {passport_photo, showAttachment, setUrl, setModalTitle} = props
    const newTitle = 'Passport Photo'
    if(passport_photo){
        return(
            <Box display="flex" className={classes.spacer} alignItems="center" mb={{ xs: 4, sm: 6 }}>
            <Box className={classes.iconView}>
              <AttachmentIcon />
            </Box>
            <Box ml={5}>
              <Box component="span" fontSize={13} color="text.primary">
              </Box>
              <Box component="p" className={classes.wordAddress}>
                  <Box component="a" href="#" onClick={e => showAttachment(e, passport_photo, setUrl, newTitle, setModalTitle)}>
                    Passport Photo
                  </Box>
              </Box>
            </Box>
          </Box>
        )
    }return null
}

const Attachments = ({ userDetail }) => {
    //const { profile } = userDetail
    const {national_id, passport_photo, passport_page, guardian_order, guardian_nin} = userDetail
    const [open, setOpen] = useState(false)
    const [url, setUrl] = useState('')
    const [modalTitle, setModalTitle] = useState('')
    const handleClickOpen = () => {
        setOpen(true);
    }
    function handleClose() {
        setOpen(false);
    };
    const showAttachment = (event, newUrl, setUrl, newTitle, setModalTitle) => {
        setUrl(newUrl)
        setModalTitle(newTitle)
        handleClickOpen()
    }
    return(
        <CmtCard elevation={2}>
        <CmtCardHeader title="Attachments" />
        <CmtCardContent>
          <NationalID national_id={national_id} showAttachment={showAttachment} setUrl={setUrl} setModalTitle={setModalTitle}/>
          <PassportPhoto passport_photo={passport_photo} showAttachment={showAttachment} setUrl={setUrl} setModalTitle={setModalTitle}/>
          <CustomizedDialog open={open} setOpen={setOpen} handleClickOpen={handleClickOpen} handleClose={handleClose} url={url} modalTitle={modalTitle}/>
        </CmtCardContent>
      </CmtCard>
    )
}

export default Attachments